<template lang="html">
    <div id="ecTabs">

    </div>
</template>

<script>
import ECDS from "@/utils/ECDs";
import { EXout } from '@/utils/excel';
import { getBuildings,getFloors } from '@/api/industryInfos';
export default {
    data(){
        return {
            Excels:{},
            exStorage:false
        }
    },
    methods:{
        HtmlCreate:function(dat,tab){
          var vm  = this;
          try {
              var headHtml = '';
              var tabHtml = '';

              var tabNames;

              if(tab == 1){
                  tabNames = ECDS.tab1;
              }else if(tab == 2){
                  tabNames = ECDS.tab2;
              }



              for(var key in tabNames){
                  headHtml = headHtml + '<td>' +
                                            tabNames[key] +
                                        '</td>';
              };

              headHtml = '<tr>' + headHtml +'</tr>';

              for(var i in dat){
                  var tds = '';
                  for(var key in tabNames){
                      tds = tds + '<td>' +
                                       this.nameExplain(key,dat[i]) +
                                  '</td>';
                  }
                  tabHtml = tabHtml + '<tr>' + tds + '</tr>';
              }

              if(tab == 1){
                  this.Exdatsever(headHtml,tabHtml,'tab1','产业空间信息（楼宇信息）');
                  this.sheetFormate();
              }else if(tab == 2){
                  this.Exdatsever(headHtml,tabHtml,'tab2','产业空间信息（空间信息）');
                  this.sheetFormate();
              }

           } catch (e) {
               alert("导出出错请重试");
               vm.exStorage.close();
           }

        },

        Exdatsever:function(headHtml,tabHtml,nameTab,nameSheet){
             tabHtml = '<table>'+ headHtml + tabHtml +'</table>';
             $("#ecTabs").html(tabHtml);
             var elt = $("#ecTabs table").get(0);
             this.Excels[nameTab] = XLSX.table_to_book(elt, {sheet:nameSheet});
        },

        nameExplain:function(key,CosDat){
            var localKey = ['isSell','actualUtilization','price1','price2','sellingInstructions','address'];
            var explains = CosDat[key];
            for(var i in localKey){
                 if(localKey[i] == key){
                       if(i == 0){
                           var arrs = ['-','出售','出租'];
                           explains = arrs[explains];
                       }else if(i == 1){
                           explains = explains + '%';
                       }else if(i == 2){
                           if(CosDat.isSell == 1){
                              explains = '-';
                           }else{
                              explains = CosDat.price;
                           }
                       }else if(i == 3){
                           if(CosDat.isSell == 1){
                               explains = CosDat.price + CosDat.sellingPriceUtil;
                           }else {
                               explains = '-';
                           }
                       }else if(i == 4){
                           if(CosDat.isSell == 2){
                              explains = '-';
                           }
                       }else if(i == 5){
                           let arr = CosDat.address.split(',');
                           explains = arr[arr.length - 1];
                       }
                       break;
                 }
            };
            return explains;
        },

        sheetFormate:function(){
             var sheets = {
                 SheetNames:[],
                 Sheets:{}
             };
             for(var key in this.Excels){
                 var sheetName = this.Excels[key].SheetNames[0];
                 sheets.SheetNames.push(sheetName);
                 sheets.Sheets[sheetName] = this.Excels[key].Sheets[sheetName];
             };

             for(var key in sheets.Sheets){
                 var scode = 0;
                 var ssure = false;
                 for(var sckey in sheets.Sheets[key]){
                      if(sckey != "!merges" && sckey != "!ref"){
                          sheets.Sheets[key][sckey].s = {
                                alignment: {
                                  vertical: "center",
                                  horizontal: "center"
                                }
                          };

                      }
                 }
             };
             EXout(sheets);
             this.exStorage.close();
        },

        metIDAsk:function(params,type){
             var vues = this;
             this.loadingWait();
             this.exStorage.text = "导出准备就绪";
             let newPms = Object.assign({},params,{size:20000})
             if(type == 1){
                this.exStorage.text = "数据拉取中...";
                getBuildings(newPms).then(res => {
                    var unFormate = res.industrialSpaceList;
                    vues.HtmlCreate(unFormate,type);
                    this.exStorage.text = "数据准备完毕";
                })
             }else if(type == 2){
                this.exStorage.text = "数据拉取中...";
                getFloors(newPms).then(res => {
                   var unFormate = res.industrialSpaceFloorWhereList;
                   vues.HtmlCreate(unFormate,type);
                   this.exStorage.text = "数据准备完毕";
                })
             }
             // getTables(dataIn).then(response => {
             //      var unFormate = response.payload.yearVerificationList;
             //      var metIdArrs = [];
             //      for(var i = 0;i < unFormate.length;i++){
             //           metIdArrs.push(unFormate[i].id);
             //      };
             //      if(metIdArrs.length > 0){
             //           vm.chainsAsk(metIdArrs,1);
             //      }
             // })
        },

        loadingWait:function(){
           const loading = this.$loading({
               lock: true,
               text: 'Loading',
               spinner: 'el-icon-loading',
               background: 'rgba(0, 0, 0, 0.7)'
           });
           this.exStorage = loading;
        }

    },
    created:function(){

    }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// ECdomPre.vue?3331fd34